<template>
  <div class="location-page">
    <div class="hero-section">
      <div class="container">
        <h1>Tandarts Vught | Tandzorg Gestel | Dichtbij Vught en Cromvoirt</h1>
        <p class="lead">
          Zoekt u een <strong>tandarts in Vught</strong>? Tandzorg Gestel in Sint-Michielsgestel
          ligt op ongeveer 8 tot 12 minuten van Vught centrum (afhankelijk van verkeer). Persoonlijke zorg en moderne tandheelkunde.
        </p>
        <p class="travel-note">Reistijden zijn indicatief en afhankelijk van verkeer en exacte vertreklocatie.</p>
      </div>
    </div>

    <div class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <h2>Waarom kiezen patiënten uit Vught voor Tandzorg Gestel?</h2>
            <p>Inwoners van <em>Vught</em>, <em>Cromvoirt</em> en <em>Helvoirt</em> waarderen onze korte reistijd en persoonlijke aanpak.</p>

            <div class="highlight-box">
              <h3>Waarom Tandzorg Gestel vanuit Vught?</h3>
              <div class="row">
                <div class="col-md-6">
                  <ul class="benefits-list">
                    <li><strong>Extra dichtbij</strong> - Ongeveer 8 tot 12 minuten vanuit Vught centrum</li>
                    <li><strong>Gratis parkeren</strong> - Ruime parkeergelegenheid</li>
                    <li><strong>Rustige locatie</strong> - Minder drukte dan in de stad</li>
                    <li><strong>Vaste behandelaar</strong> - Continuïteit en vertrouwen</li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <ul class="benefits-list">
                    <li><strong>Moderne apparatuur</strong> - Up-to-date technieken</li>
                    <li><strong>Duidelijke planning</strong> - Overzichtelijke afspraken</li>
                    <li><strong>Complete zorg</strong> - Alles onder een dak</li>
                    <li><strong>Familiepraktijk</strong> - Voor alle leeftijden</li>
                  </ul>
                </div>
              </div>
            </div>

            <h2>Route en bereikbaarheid vanuit Vught</h2>
            <p>Tandzorg Gestel is vanuit Vught en omgeving snel en eenvoudig bereikbaar.</p>

            <div class="route-section">
              <div class="row">
                <div class="col-md-6">
                  <div class="route-card">
                    <h4>Met de auto</h4>
                    <ul>
                      <li><strong>Vanuit Vught centrum:</strong><br>Via Helvoirtseweg naar Sint-Michielsgestel (8 min)</li>
                      <li><strong>Vanuit Cromvoirt:</strong><br>Via N65 richting Sint-Michielsgestel (12 min)</li>
                      <li><strong>Vanuit Helvoirt:</strong><br>Via Bosscheweg richting praktijk (10 min)</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="route-card">
                    <h4>Openbaar vervoer</h4>
                    <ul>
                      <li><strong>Buslijn:</strong><br>Via Vught station naar Sint-Michielsgestel</li>
                      <li><strong>Fiets:</strong><br>Goede fietsroute via de regio</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <h2>Afspraak maken vanuit Vught</h2>
            <p>Plan eenvoudig online een afspraak of neem contact op met onze praktijk.</p>
            <div class="cta-buttons">
              <router-link to="/afspraak-maken" class="btn btn-primary">Afspraak Maken</router-link>
              <router-link to="/contact" class="btn btn-secondary">Contact</router-link>
            </div>
          </div>

          <div class="col-md-4">
            <div class="sidebar">
              <div class="contact-card">
                <h3>Bereikbaarheid</h3>
                <div class="contact-info">
                  <p><strong>Adres:</strong><br>Schijndelseweg 13A<br>5271 BK Sint-Michielsgestel</p>
                  <p><strong>Telefoon:</strong><br>073 - 551 5644</p>
                  <p><strong>Afstand vanuit Vught:</strong><br>8 tot 12 minuten rijden</p>
                </div>
              </div>

              <LocalRouteMap
                city-name="Vught"
                origin-query="Vught, Nederland"
                drive-time="ongeveer 8 tot 12 minuten"
                transit-time="ongeveer 15 tot 25 minuten"
              />

              <div class="hours-card">
                <h3>Openingstijden</h3>
                <div class="hours-grid">
                  <div class="hours-row"><span class="day">Maandag</span><span class="time">8:00 - 17:00</span></div>
                  <div class="hours-row"><span class="day">Dinsdag</span><span class="time">8:00 - 17:00</span></div>
                  <div class="hours-row"><span class="day">Woensdag</span><span class="time">8:00 - 17:00</span></div>
                  <div class="hours-row"><span class="day">Donderdag</span><span class="time">8:00 - 17:00</span></div>
                  <div class="hours-row"><span class="day">Vrijdag</span><span class="time">8:00 - 17:00</span></div>
                  <div class="hours-row"><span class="day">Zondag</span><span class="time">Gesloten</span></div>
                </div>
              </div>

              <div class="specialties-card">
                <h3>Onze Specialiteiten</h3>
                <ul class="specialties-list">
                  <li>✓ Lid van De Lieve Tandarts</li>
                  <li>✓ Moderne technieken</li>
                  <li>✓ Persoonlijke aandacht</li>
                  <li>✓ Ervaren team</li>
                  <li>✓ Complete zorg</li>
                  <li>✓ Kindvriendelijke praktijk</li>
                </ul>
              </div>

              <div class="emergency-card">
                <h3>Spoedgevallen</h3>
                <p>Tandpijn of spoedgeval? Ook vanuit Vught helpen we u snel.</p>
                <router-link to="/spoed" class="emergency-btn">
                  <i class="fas fa-exclamation-triangle"></i> Spoedhulp
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocalRouteMap from '../components/LocalRouteMap.vue'

export default {
  name: 'TandartsVught',
  components: { LocalRouteMap },
  mounted() {
    document.title = 'Tandarts Vught | Tandzorg Gestel Sint-Michielsgestel | Ongeveer 8-12 Min Rijden'

    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Tandarts Vught gezocht? Tandzorg Gestel in Sint-Michielsgestel ligt op ongeveer 8 tot 12 minuten van Vught (afhankelijk van verkeer). Persoonlijke zorg, gratis parkeren, moderne technieken. Nieuwe patiënten welkom!')
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'tandarts Vught, tandarts 5261, tandarts Cromvoirt, tandarts Helvoirt, tandheelkunde Vught, Sint-Michielsgestel, Tandzorg Gestel')
    }
  }
}
</script>

<style scoped>
.location-page { padding-top: 120px; }
.hero-section { background: linear-gradient(135deg, #fff7e6 0%, #e8f4fd 100%); padding: 60px 0; margin-bottom: 40px; }
.hero-section h1 { font-size: 2.5rem; color: var(--black); margin-bottom: 1rem; font-weight: 700; }

.travel-note {
  font-size: 1.3rem;
  color: var(--light-color);
  margin-top: 0.8rem;
  font-style: italic;
}
.content-section { padding-bottom: 60px; }
.content-section h2 { font-size: 2.2rem; margin: 2rem 0 1rem; color: var(--black); }
.content-section h3 { font-size: 1.8rem; margin: 1.5rem 0 1rem; color: var(--black); }
.content-section h4 { font-size: 1.3rem; color: var(--blue); margin-bottom: 1rem; }
.content-section p, .content-section li { font-size: 1.6rem; line-height: 1.8; color: var(--light-color); }

.highlight-box, .benefits-list, .route-info, .route-card, .benefit-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
  border-radius: 12px;
  border-left: 4px solid var(--blue);
}

.highlight-box { padding: 2rem; margin: 2rem 0; }
.highlight-box h3 { color: var(--blue); margin-bottom: 1.5rem; font-size: 1.4rem; }
.benefits-list { list-style: none; padding: 2rem; margin: 2rem 0; border-left-width: 4px; }
.benefits-list li { padding: 0.5rem 0 0.5rem 1.5rem; position: relative; }
.benefits-list li:before { content: "✓"; position: absolute; left: 0; color: var(--blue); font-weight: bold; }

.route-section, .route-info { margin: 3rem 0; padding: 2rem; }
.route-info ul { margin-bottom: 0; }
.route-card {
  background: white;
  border-left: 0;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  padding: 2rem;
  height: 100%;
}
.route-card ul { list-style: none; padding: 0; margin: 0; }
.route-card li { padding: 0.8rem 0; border-bottom: 1px solid #f0f0f0; }
.route-card li:last-child { border-bottom: none; }
.route-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1.2rem; }
.route-item { background: white; border: 1px solid #e7e7e7; border-radius: 8px; padding: 1.2rem; }
.duration { color: var(--blue); font-weight: 600; }

.cta-buttons, .quick-actions { display: flex; gap: 1rem; flex-wrap: wrap; margin-top: 2rem; }
.btn, .btn-link {
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.btn-primary, .btn-link, .cta-card .btn-primary { background: var(--blue); color: white; border: 2px solid var(--blue); }
.btn-primary:hover, .btn-link:hover, .cta-card .btn-primary:hover { background: var(--dark-blue); color: white; transform: translateY(-2px); text-decoration: none; }
.btn-secondary { background: white; color: var(--blue); border: 2px solid var(--blue); }
.btn-secondary:hover { background: var(--blue); color: white; }

.sidebar { position: sticky; top: 130px; }
.contact-card,
.hours-card,
.specialties-card,
.emergency-card,
.appointment-card,
.directions-card,
.info-card,
.location-card,
.cta-card,
.quick-links-card,
.why-us-card,
.local-links {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}
.contact-card h3,
.hours-card h3,
.specialties-card h3,
.emergency-card h3,
.appointment-card h3,
.directions-card h4,
.info-card h3,
.location-card h3,
.cta-card h3,
.quick-links-card h3,
.why-us-card h3,
.local-links h3 { color: var(--blue); margin-bottom: 1rem; font-size: 1.3rem; }

.hours-grid, .hours-table { display: flex; flex-direction: column; gap: 0.5rem; }
.hours-row { display: flex; justify-content: space-between; align-items: center; padding: 0.5rem 0; border-bottom: 1px solid #f0f0f0; }
.hours-row:last-child { border-bottom: none; }
.day { font-weight: 600; color: var(--black); }
.time, .hours { color: var(--light-color); }

.specialties-list,
.opening-hours,
.why-us,
.why-us-list,
.quick-links,
.local-links ul,
.distance-info ul { list-style: none; padding: 0; margin: 0; }
.specialties-list li,
.opening-hours li,
.why-us li,
.why-us-list li,
.local-links li,
.distance-info li { padding: 0.4rem 0; color: var(--light-color); border-bottom: 1px solid #f0f0f0; }
.specialties-list li:last-child,
.opening-hours li:last-child,
.why-us li:last-child,
.why-us-list li:last-child,
.local-links li:last-child,
.distance-info li:last-child { border-bottom: none; }

.quick-link {
  display: block;
  margin-bottom: 0.7rem;
  padding: 0.8rem 1rem;
  border-radius: 8px;
  background: #f8f9fa;
  color: var(--light-color);
  text-decoration: none;
  border: 1px solid #ececec;
}
.quick-link:hover { color: var(--blue); background: #eef6ff; text-decoration: none; }

.emergency-card { background: linear-gradient(135deg, #fff5f5 0%, #ffebee 100%); }
.emergency-btn {
  background: #dc3545;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  margin-top: 1rem;
}
.emergency-btn:hover { background: #c82333; transform: translateY(-2px); color: white; }

@media (max-width: 992px) {
  .route-grid { grid-template-columns: 1fr; }
}

@media (max-width: 768px) {
  .location-page { padding-top: 100px; }
  .hero-section h1 { font-size: 2rem; }
  .row { flex-direction: column; gap: 2rem; }
  .cta-buttons, .quick-actions { flex-direction: column; align-items: stretch; }
  .btn, .btn-link { width: 100%; justify-content: center; }
  .sidebar { position: static; margin-top: 2rem; }
  .highlight-box, .route-card, .route-info, .benefits-list { padding: 1.5rem; }
}
</style>

